export default __webpack_public_path__ + "static/media/logo_only.0131915c.svg";